<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="字典名称">
              <a-input v-model="queryParam.name" placeholder="请输入字典名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="字典代码">
              <a-input v-model="queryParam.type" placeholder="请输入字典代码"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button type="primary"@click="() => {this.queryPage()}">查询</a-button>
            <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="$refs.dictAddOrUpdate.init('','add')" v-action="'sys:dict:save'">新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :columns="columns"
      :alert="alert"
      :data="loadData"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :rowKey="record => record.id"
    >
      <span slot="action" slot-scope="text, record">
        <span v-action="'sys:dict:update'">
          <a @click="edit(record)">修改</a>
          <a-divider type="vertical" />
        </span>
        <span>
          <a href="javascript:;" @click="showDictItem(record)">字典配置</a>
          <a-divider type="vertical" />
        </span>
        <span v-action="'sys:dict:del'">
          <a-popconfirm title="是否删除字典" @confirm="del(record)" okText="是" cancelText="否">
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <a href="javascript:;" style="color: red">删除</a>
          </a-popconfirm>
        </span>
      </span>
    </s-table>
    <dict-add-or-update
      ref="dictAddOrUpdate"
      @ok="queryPage"
    />
    <dict-item-drawer
      ref="dictItemDrawer"
    />
  </a-card>
</template>

<script>
import { fetchList, delObj } from '@api/sys/dict'
import DictAddOrUpdate from './dictAddOrUpdate'
import DictItemDrawer from './dictItemDrawer'
import { TableMixin } from '@/mixins/TableMixin'

export default {
  name: 'Dict',
  mixins: [TableMixin],
  components: {
    DictAddOrUpdate,
    DictItemDrawer
  },
  data () {
    return {
      columns: [
        {
          title: '#',
          width: '10%',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        }, {
          title: '字典名称',
          width: '10%',
          dataIndex: 'name'
        }, {
          title: '字典类型',
          width: '10%',
          dataIndex: 'type'
        }, {
          title: '描述',
          dataIndex: 'remark'
        },
        {
          title: '操作',
          width: '350px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      queryParam: {
        name: '',
        type: ''
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      }
    }
  },
  methods: {
    edit (record) {
      this.$refs.dictAddOrUpdate.init(record.id, 'edit')
    },
    del (record) {
      delObj(record.id).then(_ => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    },
    showDictItem (record) {
      this.$refs.dictItemDrawer.init(record)
    }
  }
}
</script>

<style scoped>

</style>
